import React from 'react';

const CreateProfile = () => {
  const profile: object = {};

  return (
    <>
      <p>Create profile</p>
    </>
  );
};

export default CreateProfile;
